import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { filterRepairers } from "../../../store/action/repairer";
import GarageCart from './GarageCart';

const useStyles = makeStyles((theme) => ({
    cardContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    inputContainer: {
        border: "0.61px solid rgba(226, 217, 239, 1)",
        background: "rgba(255, 255, 255, 1)",
        width: "200px",
        height: "36px",
        borderRadius: 5,
        marginLeft: "20px",
    },
    titre: {
        fontFamily: "Poppins",
        fontSize: 16,
        fontWeight: 600,
        color: "rgba(63, 66, 84, 1)",
    },
    titreLabel: {
        fontFamily: "Poppins",
        fontSize: 14,
        fontWeight: 400,
        color: "rgba(32, 18, 70, 1)",
    },
    loadingText: {
        fontSize: '16px',
        color: 'gray',
    },
    noRepairersText: {
        fontSize: '16px',
        color: 'red',
    },
}));

const GarageSelection = ({ designatedGarages, filters }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [selectedRepairer, setSelectedRepairer] = useState(null);
    const [dataRepairers, setDataRepairers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [nomFiltre, setNomFiltre] = useState("");
    const [regionFiltre, setRegionFiltre] = useState("");
    const [gouvernoratFiltre, setGouvernoratFiltre] = useState("");

    const handleRepairerSelect = (repairer) => {
        designatedGarages(repairer);
        setSelectedRepairer(repairer);
    };

    const handleNomChange = (e) => setNomFiltre(e.target.value.toLowerCase());
    const handleRegionChange = (e) => setRegionFiltre(e.target.value.toLowerCase());
    const handleGouvernoratChange = (e) => setGouvernoratFiltre(e.target.value.toLowerCase());

    const getRepairers = async (filtersForRepairers) => {
        setLoading(true);
        try {
            const GOUVERNORAT = filtersForRepairers.find(object => object.key === 'GOUVERNORAT')?.value || null;
            const SCOPE = filtersForRepairers.find(object => object.key === 'SCOPE')?.value || null;
            const data = await dispatch(filterRepairers(filtersForRepairers.filter(object => object.key === 'SCOPE')));
            
            let newData = data;
            if (GOUVERNORAT && SCOPE !== 'AUTOP') {
                newData = data.filter(object => 
                    object.caracteristiques.some(caracteristique => 
                        caracteristique.key === 'GOUVERNORAT' && caracteristique.value === GOUVERNORAT
                    )
                );
            }
            
            setDataRepairers(newData.length > 0 ? newData : data);
        } catch (error) {
            console.error("Error fetching repairers:", error);
            // Optionally, you can set an error state here to display an error message
        } finally {
            setLoading(false);
        }
    };

    const filteredRepairersF = useMemo(() => {
        let dataFiltered = dataRepairers;
         
        if (nomFiltre) {
            dataFiltered = dataFiltered.filter((organization) =>
                organization.organizationName?.toLowerCase().includes(nomFiltre.toLowerCase())
            );
        }

        if (regionFiltre) {
            dataFiltered = dataFiltered.filter((organization) =>
                organization.caracteristiques?.some(caracteristique =>
                    caracteristique.key === 'REGION' && caracteristique.value.toLowerCase().includes(regionFiltre.toLowerCase())
                )
            );
        }

        if (gouvernoratFiltre) {
            dataFiltered = dataFiltered.filter((organization) =>
                organization.caracteristiques?.some(caracteristique =>
                    caracteristique.key === 'GOUVERNORAT' && caracteristique.value.toLowerCase().includes(gouvernoratFiltre.toLowerCase())
                )
            );
        }
        
        return dataFiltered;
    }, [dataRepairers, nomFiltre, regionFiltre, gouvernoratFiltre]);

    useEffect(() => {
        getRepairers(filters);
    }, [filters]);

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center" ,margin : "20px"}}>
                <div className={classes.titre} style={{ marginRight: "15px", whiteSpace: "nowrap" }}>
                    Filtrer par
                </div>
                
                <div className={classes.titreLabel} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap", marginLeft: "1rem" }}>
                    Nom
                    <input
                        type="text"
                        className={classes.inputContainer}
                        onChange={handleNomChange}
                        aria-label="Nom du réparateur"
                    />
                </div>
                <div className={classes.titreLabel} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap", marginLeft: "1rem" }}>
                    Gouvernorat
                    <input
                        type="text"
                        className={classes.inputContainer}
                        onChange={handleGouvernoratChange}
                        aria-label="Gouvernorat du réparateur"
                    />
                </div>  
                <div className={classes.titreLabel} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap", marginLeft: "1rem" }}>
                    Région
                    <input
                        type="text"
                        className={classes.inputContainer}
                        onChange={handleRegionChange}
                        aria-label="Région du réparateur"
                    />
                </div>
         

            </div>
            <div className={classes.cardContainer}>
                {loading ? (
                    <p className={classes.loadingText}>Chargement des Réparateurs...</p>
                ) : filteredRepairersF.length > 0 ? (
                    filteredRepairersF.map((repairer) => (
                        <GarageCart
                            key={repairer.id} // Assuming each repairer has a unique id
                            filteredRepairers={repairer}
                            designated={() => handleRepairerSelect(repairer)}
                            selectedRepairer={selectedRepairer}
                            width={'30%'}
                            height={'Auto'}
                        />
                    ))
                ) : (
                    <p className={classes.noRepairersText}>Aucun Réparateur disponible</p>
                )}
            </div>
        </div>
    );
};

export default GarageSelection;